import React from "react";
import utils from "../../modules/utils";
import axios from "axios";
import RecapCF from "./recap_cf";
import BoxClink from "./components/BoxClink"
import moment from "moment";
import {
  setDatiPersonali,
  setDoveNoReset,
  setConsensi,
  clearConsensi,
  setOppID,
  setRecap,
  saveToken,
  setProdotto,
  setRicontattoRichiesto
} from "../../actions/index";
import { connect } from "react-redux";
import apiInvoker from "../../modules/apiInvoker";
import Spinner from "../shared/spinner.js";
import { trackOppId, trackContactID, trackClinkCTAShow, trackClinkCTAClick, trackEmail, trackPhone, stopDigitalAssistant } from "../../modules/datalayer.js";
import FormAuxiliaryInfo from "./components/FormAuxiliaryInfo";
import FormInputTextDisabled from '../shared/disabled_input';
import Consolidamento from "./consolidamento";
//import Distante from "./distante";
/* Flow */
import { handleFlow } from '../../flow/flow';

let cta_tracked = false;

const mapDispatchToProps = dispatch => {
  return {
    setDatiPersonali: type => dispatch(setDatiPersonali(type)),
    setDoveNoReset: d => dispatch(setDoveNoReset(d)),
    setConsensi: type => dispatch(setConsensi(type)),
    clearConsensi: c => dispatch(clearConsensi(c)),
    setOppID: o => dispatch(setOppID(o)),
    setRecap: r => dispatch(setRecap(r)),
    saveToken: t => dispatch(saveToken(t)),
    setProdotto: t => dispatch(setProdotto(t)),
    setRicontattoRichiesto: rr => dispatch(setRicontattoRichiesto(rr))
  };
};

const mapStateToProps = state => {
  return {
    recap_cf_accettato: state.recap_cf_accettato,
    prodotto: state.prodotto,
    utente: state.utente,
    oppID: state.oppID,
    excluded: state.cap_excluded,
    flowSwitch: state.flowSwitch,
  };
};

let autocomplete_timeout;

const checkUserData = (prodotto, utente) => {
  if(
    (prodotto == 1 || prodotto == 3  || prodotto == 4)
    && 
    ( 
      !utente 
      || 
      (
        (!utente.nome || utente.nome == "")
        || (!utente.cognome || utente.cognome == "")
        || (!utente.email || utente.email == "")
        || (!utente.telefono || utente.telefono == "")
        || (!utente.codice_fiscale || utente.codice_fiscale == "")
      ) 
    )
  ) {
    return false;
  }

  return true;
}

const checkRiepilogoInfo = (recap_cf_accettato, prodotto, utente, modificaDatiRiconosciuti) => {
  const gState = utils.getState();
  let hideRecap = (
    recap_cf_accettato
    ||
    (
      !recap_cf_accettato
      && (prodotto == 1 || prodotto == 4 || prodotto == 3) //2022-07-01 Anche C5 ha il recap
      && !checkUserData(prodotto, utente)
    )
  );
  if (gState.access_route == '/clink' && !modificaDatiRiconosciuti ) {//se arrivano da clink hanno sempre il recap
    hideRecap = false;
  }
  return hideRecap;
}

const checkEditInfo = (recap_cf_accettato, oppID, prodotto, utente, modificaDatiRiconosciuti) => { 
  let showEditInfo = (
    (
      recap_cf_accettato
      &&
      (
        !oppID
        || oppID == ""
      ) /*|| invalid_user_data*/
    )
    ||
    (
      !recap_cf_accettato
      &&
      !checkUserData(prodotto, utente)
    )
  );
  const gState = utils.getState();
  if (gState.access_route == '/clink' && !modificaDatiRiconosciuti) {
    showEditInfo = false;
  }
  return showEditInfo; 
}

class FormDatiPersonali extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nome: "",
      cognome: "",
      email: "",
      telefono: "",
      cap: "",
      cap_ricavato_gmaps: "",
      formatted_address: "",
      provincia: "",
      ricontatto: 0,
      comune: "",
      correct_submit: false,
      cap_label: "CAP",
      suggestions: [],
      citta: "",
      valutazione: "",
      informativa: "",
      dati_personali: "",
      societa_terze: "",
      valutazione: "",
      loading: false,
      impiego: "",
      iscrittoCameraCommercio: false,
      tipoAzienda: "",
      errors: {},
      modificaDatiRiconosciuti: false,
      consolidamento: 0,
      clink: 0
    };
    this.handleRadio = this.handleRadio.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleConsolidamento = this.handleConsolidamento.bind(this);
    this.handleVeniamoDaTe = this.handleVeniamoDaTe.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleModificaDati = this.handleModificaDati.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
    this.autoFill = this.autoFill.bind(this);
    this.handleAutofill = this.handleAutofill.bind(this);
    this.sendRicontatto = this.sendRicontatto.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.CTAClinkVisible = this.CTAClinkVisible.bind(this);
    this.handleClink = this.handleClink.bind(this);
  }

  componentDidMount() {
    stopDigitalAssistant();
    const global_state = utils.getState();
    if (
      global_state.utente &&
      global_state.dati_locali &&
      global_state.dati_locali.utente &&
      global_state.utente.token &&
      global_state.utente.token !== "" &&
      global_state.utente.consensi &&
      (typeof global_state.utente.consensi.informativa != "undefined" && global_state.utente.consensi.informativa != null) &&
      (typeof global_state.utente.consensi.societa_terze != "undefined" && global_state.utente.consensi.societa_terze != null) &&
      (typeof global_state.utente.consensi.dati_personali != "undefined" && global_state.utente.consensi.dati_personali != null)
    ) {
      //Se abbiamo il token e i consensi proviamo a fissare
      this.setState({
        nome: global_state.dati_locali.utente.nome || "",
        cognome: global_state.dati_locali.utente.cognome || "",
        email: global_state.dati_locali.utente.email || "",
        telefono: global_state.dati_locali.utente.telefono || "",
        cap: global_state.dati_locali.utente.cap || "",
        provincia: global_state.dati_locali.utente.provincia || "",
        comune: global_state.dati_locali.utente.comune || ""
      });
      this.handleSubmit();
    } else {
      if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
        this.setState({
          cap_label: "Indirizzo"
        });
        this.state.prodotto = global_state.prodotto;
      }
      if (global_state.dati_locali.utente) {
        this.setState({
          nome: global_state.dati_locali.utente.nome || "",
          cognome: global_state.dati_locali.utente.cognome || "",
          email: global_state.dati_locali.utente.email || "",
          telefono: global_state.dati_locali.utente.telefono || "",
          cap: global_state.dati_locali.utente.cap || "",
          impiego: global_state.dati_locali.utente.impiego || "",
          provincia: global_state.dati_locali.utente.provincia || "",
          comune: global_state.dati_locali.utente.comune || ""
        });
        if (global_state.dati_locali.utente.impiego) {
          let impiegoValue = utils.convertImportoValue(global_state.dati_locali.utente.impiego);

          if (typeof impiegoValue == 'string' && impiegoValue.indexOf('2:')!=-1) {
            impiegoValue = "2";
          }
          const checkboxEl = document.querySelector(
            "input[type='radio'][value='" +
            impiegoValue +
            "']"
          )
          if (checkboxEl) {
            checkboxEl.checked = true;
          }
        }
      }
    }
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll() {
    const ctaInViewport = utils.elementInViewport('#box-clink', 50);
    const global_state = utils.getState();
    if (ctaInViewport && !cta_tracked) {
      if (global_state.ricontatto == true && global_state.ricontatto_cf == true) {
        cta_tracked = true;
        trackClinkCTAShow();
      }
    }
  }
  handleConsolidamento(val) {
    this.setState({
      'consolidamento': val
    })
  }
  handleClink(val) {
    let upd_obj = {
      'clink': val
    }
    if (val == 1) {
      upd_obj.ricontatto = true;
      this.props.setRicontattoRichiesto(true);
    } else {
      upd_obj.ricontatto = false;
      this.props.setRicontattoRichiesto(false);
    }
    this.setState(upd_obj)
  }
  handleClick(event) {
    event.target.focus();
  }

  handleVeniamoDaTe(val) {
    this.setState({
      'ricontatto': val
    })
  }

  sendRicontatto() {
    let self = this;
    this.props.setRicontattoRichiesto(true);
    this.setState({
      "ricontatto": true
    }, function () {
        self.handleSubmit();
    });
  }

  handleRadio(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    radio.checked = true;

    if (radio.name === "valutazione" && radio.value == -1) {
      let errors = this.state.errors;
      errors["valutazione"] = "il consenso è obbligatorio per il prosieguo del processo";
      this.setState({
        [radio.name]: radio.value == 1 ? true : false,
        errors: errors
      });
    } else {
      let errors = this.state.errors;
      delete errors[radio.name];
      this.setState({
        [radio.name]: radio.value == 1 ? true : false,
        errors: errors
      });
    }
  }

  handleInput(validationType, event) {
    //Valido il campo modificato
    const global_state = utils.getState();
    let validations = validationType.split("|"); //Recupero tutte la validazioni richieste sul campo
    let self = this; //Salvo in variabile this per usarlo nello scope del foreach
    validations.forEach(function (validation) {
      //Scorro tutti i tipi di validazione richiesti
      let errors = self.state.errors; //Recupero lo stato degli errori prima dell'elaborazione

      errors = self.validate(
        validation,
        event.target.name,
        event.target.value,
        errors
      );

      //Reimposto lo stato degli errori
      self.setState({
        errors: errors
      });
    });
    //Imposto il valore digitato dall'utente
    let field = {};
    let new_value = event.target.value;
    if (event.target.name == 'email' || event.target.name == 'telefono' || (event.target.name == 'cap' && global_state.prodotto != -1 && global_state.prodotto != 3 && global_state.prodotto!=5)) {
      new_value = new_value.trim();
    }
    field[event.target.name] = new_value;
    this.setState(field);
  }
  handleCheck(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    let value;
    let errors = this.state.errors;

    radio.checked = true;
    delete errors[radio.name];

    switch (radio.value) {
      case "true":
        value = true;
        break;
      case "false":
        value = false;
        break;
      default:
        value = radio.value;
    }

    this.setState({
      [radio.name]: value,
      errors: errors
    });
  }
  autoFill(e) {
    let suggestion = e.target.getAttribute("suggestion");
    this.setState({
      cap: suggestion,
      formatted_address: suggestion,
      suggestions: []
    });
  }
  handleModificaDati() {
    this.props.clearConsensi();
    this.props.setDatiPersonali({
      cancella_dati_locali: true
    });
    this.props.setRecap(true);
    this.setState({
      email: "",
      telefono: "",
      cap: "",
      cap_ricavato_gmaps: "",
      impiego: "",
      modificaDatiRiconosciuti: true
    });
    let radios = window.document.querySelectorAll(
      "#radio-impiego input[type='radio']"
    );
    if (radios && radios.length > 0) {
      for (let r in radios) {
        let radio = radios[r];
        if (isNaN(radio)) {
          //non processiamo la length
          radio.checked = false;
        }
      }
    }
  }
  handleKeyup() {
    const global_state = utils.getState();
    let self = this;
    if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
      clearTimeout(autocomplete_timeout);
      autocomplete_timeout = setTimeout(function () {
        let value = document.getElementById("a_search").value;
        self.setState({
          suggestions: [],
          selected_suggestion: ""
        });
        if (value.length > 3) {
          let cap_generici = {
            "00100": "00100 Roma, Italia",
            "0010": "00100 Roma, Italia",
            "10100": "10100 Torino, Italia",
            "1010": "10100 Torino, Italia",
            "20100": "20100 Milano, Italia",
            "2010": "20100 Milano, Italia",
            "80100": "80100 Napoli, Italia",
            "8010": "80100 Napoli, Italia",
            "90100": "90100 Palermo, Italia",
            "9010": "90100 Palermo, Italia",
            "16100": "16100 Genova, Italia",
            "1610": "16100 Genova, Italia",
            "40100": "40100 Bologna, Italia",
            "4010": "40100 Bologna, Italia",
            "50100": "50100 Firenze, Italia",
            "5010": "50100 Firenze, Italia",
            "70100": "70100 Bari, Italia",
            "7010": "70100 Bari, Italia",
            "95100": "95100 Catania, Italia",
            "9510": "95100 Catania, Italia",
            "30100": "30100 Venezia, Italia",
            "3010": "30100 Venezia, Italia",
            "37100": "37100 Verona, Italia",
            "3710": "37100 Verona, Italia",
            "98100": "98100 Messina, Italia",
            "9810": "98100 Messina, Italia",
            "35100": "35100 Padova, Italia",
            "3510": "35100 Padova, Italia",
            "34100": "34100 Trieste, Italia",
            "3410": "34100 Trieste, Italia"
          };
          if (cap_generici.hasOwnProperty(value)) {
            self.setState({
              suggestions: [cap_generici[value]]
            });
          } else {
            /*let input = window.document.getElementById("a_search");
            let autocomplete = new window.google.maps.places.Autocomplete(input, {
              componentRestrictions: { country: "it" }
            });
            autocomplete.addListener('place_changed', function () {
              let place = autocomplete.getPlace();
              window.document.getElementById("a_search").value = place.formatted_address;
              self.setState({
                'cap': place.formatted_address
              })
            });*/

            let search = new window.mapkit.Search({ 
              language: "it",
              getsUserLocation: false,
              region: new window.mapkit.CoordinateRegion(new window.mapkit.Coordinate(parseFloat(self.state.latTarget), parseFloat(self.state.longTarget)), new window.mapkit.CoordinateSpan(0.010, 0.010)),
              limitToCountries: "it"
            });
            /*if (!isNaN(value)) {
              value = "Italy " + value;
            }*/

            search.autocomplete(value, function (err, res) {
              if (!err) {
                let sugg = [];
                res.results.map((obj, index) => {
                  if (index < 5) {
                    let com1 = obj.displayLines[0] ? obj.displayLines[0].replace("Cerca nei dintorni", "") : "";
                    let com2 = obj.displayLines[1] ? obj.displayLines[1].replace("Cerca nei dintorni", "") : "";
                    let sugg_string = com1 + " " + com2;
                    sugg.push(sugg_string)
                  }
                });
                self.setState({
                  'suggestions': sugg
                });
              }
            });
          }
        }
      }, 700)
    }
  }
  validateConsensiAndSubmit(self) {
    let global_state = utils.getState();
    if (
      (global_state.utente &&
        global_state.utente.token &&
        global_state.utente.token !== "") ||
      validaConsensi(self)
    ) {
      //2020-03-04 Disattivata la compilazione automatica da token perchè DS ha smesso di passarceli
      /*if (!global_state.utente.token || global_state.utente.token === "") {
        //se non arrivo da token valorizzo i consensi
        self.props.setConsensi({
          informativa: self.state.informativa,
          dati_personali: self.state.dati_personali,
          societa_terze: self.state.societa_terze
        });
      }*/

      //Se non ho i consensi prendo quelli del form, in caso contrario ignoro (Forzoso)
      if (
        global_state
        && global_state.utente
        && (!global_state.utente.consensi || !global_state.utente.consensi.informativa || !global_state.utente.consensi.dati_personali || !global_state.utente.consensi.societa_terze)
      ) {
        self.props.setConsensi({
          informativa: self.state.informativa,
          dati_personali: self.state.dati_personali,
          societa_terze: self.state.societa_terze
        });
      }

      let data_appuntamento;

      if (
        typeof global_state.data_appuntamento != "undefined" &&
        global_state.data_appuntamento !== ""
      ) {
        data_appuntamento = moment(
          global_state.data_appuntamento +
          " " +
          global_state.orario_appuntamento
        ).format("YYYY-MM-DD HH:mm");
      } else {
        data_appuntamento = moment().format("YYYY-MM-DD HH:mm");
      }
      let isModifica = global_state.oppID ? true : false;
      let utm_term = window.printParam("utm_term");
      if ((!utm_term || utm_term == "") && global_state.prodotto != -1 && global_state.prodotto != 3) {
        utm_term = "Nuovo fissa appuntamento";
      }
      global_state = utils.getState(); //aggiorno lo state
      if (utils.isCapExluded(global_state.utente.cap)) {
        utils.showErrorModal("Errore generico, riprova più tardi", 500);
        self.submitBtn.removeAttribute("disabled");
        this.setState({
          'loading': false
        })
        return false;
      }
      let prodotto_in = global_state.prodotto;
      if(this.props.excluded) {
        prodotto_in = -1;
      }
      const comune = typeof global_state.utente.comune != 'undefined' ? global_state.utente.comune.toUpperCase() : global_state.utente.comune;
      const nome_utente = global_state.utente.nome || self.state.nome;
      const cognome_utente = global_state.utente.cognome || self.state.cognome;
      let indirizzoRes = ((global_state.prodotto == 3 || global_state.prodotto == 5) && global_state.utente.cap) ? global_state.utente.cap.split(',')[0] : '';
      const userEmail = global_state.utente.email || this.state.email;
      let body = {
        filiale: global_state.id_filiale,
        data: data_appuntamento,
        nome: nome_utente,
        cognome: cognome_utente,
        email: userEmail,
        cellulare: global_state.utente.telefono,
        capResidenza: (global_state.prodotto != 3 && global_state.prodotto != 5) ? global_state.utente.cap : '',
        provinciaResidenza: global_state.utente.provincia,
        comuneResidenza: comune,
        codiceFiscale: global_state.utente.codice_fiscale,
        privacyExtcommoffer: (global_state.utente.consensi && global_state.utente.consensi.informativa) ? 1 : 0,
        privacyProfilazione: (global_state.utente.consensi && global_state.utente.consensi.societa_terze) ? 1 : 0,
        privacyOtherservice: (global_state.utente.consensi && global_state.utente.consensi.dati_personali) ? 1 : 0,
        privacyInterncommoffer: (this.state.valutazione ? 1 : 0),
        valutazione: this.state.valutazione ? 1 : 0, //Retrocompatibilità
        tipoOccupazione: global_state.utente.impiego,
        iscrittoCameraCommercio: global_state.utente.iscrittoCameraCommercio,
        tipoAzienda: global_state.utente.tipoAzienda,
        oppID: global_state.oppID,
        prodotto: prodotto_in,
        PosizioneCliente: global_state.coordinate_luogo,
        utm_source: window.printParam("utm_source"),
        utm_medium: window.printParam("utm_medium"),
        utm_campaign: window.printParam("utm_campaign"),
        utm_date: window.printParam("utm_date"),
        utm_history: window.printParam("utm_history"), //Gestito da trackingManager
        utm_content: window.printParam("utm_content"),
        utm_term: utm_term,
        mediacode: window.printParam("mediacode"), //Gestito da trackingManager
        source: global_state.source,
        consolidamento: self.state.consolidamento,
        ricontatto: (self.state.ricontatto=="1" ? 1 : 0),
        TipoFiliali: (global_state.prodotto == 3 || self.props.flowSwitch.previousFlow == 3) ? 1 : 0,
        indirizzoResidenza: indirizzoRes,
      };
      if (
        global_state.prodotto==5
        && (!body.PosizioneCliente
            || (
              body.PosizioneCliente
              && (!body.PosizioneCliente.lat || !body.PosizioneCliente.lng)
            )
          )
      ) {
        body.PosizioneCliente = {
          lat: 0,
          lng: 0
        }
      }
      trackEmail(global_state.utente.email);
      trackPhone(global_state.utente.telefono);
      const ricontatto_param = utils.getUrlParameter('ricontatto');
      if (global_state.ricontatto == true && global_state.ricontatto_cf == true) { //è apparso il box clink, tracciamo la scelta
        trackClinkCTAClick(self.state.ricontatto == "1" ? "Si" : "No");
      }
      if (self.state.ricontatto == true || self.state.ricontatto == 1 || self.state.ricontatto == "1") { //Il cliente ha optato per essere richiamato da un agente che vada a casa sua
        self.props.setRicontattoRichiesto(true);
        body.filiale = global_state.filiale_ricontatto;
      }
      if (ricontatto_param == "true" || ricontatto_param == true || ricontatto_param == 1 || ricontatto_param == "1") { //Arriviamo da DS
        console.log("Impostato ricontatto");
        self.props.setRicontattoRichiesto(true);
        body.ricontatto = 1;
      }

      if (global_state.prodotto == -2) { //Contact center per emergenza
        body['valutazione'] = self.state.valutazione ? 1 : 0;
      }

      if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
        document
          .querySelector('button[type="submit"]')
          .setAttribute("disabled", "");
      }

      const httpClient = axios.create();
      httpClient.defaults.timeout = 50000;
      apiInvoker.CreaAppuntamentoAsync(
        body,
        res => {
          self.submitBtn.removeAttribute("disabled");
          this.setState({
            loading: false
          });
          if (res.status == 200) {
            self.props.saveToken(null); //Rimuovo il token per poter andare in TYP
            const ws_result = res.data;
            const tracking_url = ws_result.trackingUrl || "";
            if (ws_result && ws_result.chiusuraStraordinaria && ws_result.chiusuraStraordinaria===true) {
              self.props.setProdotto(-2);
            }
            if (ws_result.codRes == 0 || ws_result.codRes == 200) { //Dovrebbe essere 0 ma ogni tanto a random ci passano 200
              //Mi sposto al riepilogo
              if (ws_result.oppID) {
                self.props.setOppID(ws_result.oppID);
                trackOppId(ws_result.oppID);
                trackContactID(ws_result.contactID);
              }
              
              if (tracking_url != "") {
                axios.get(tracking_url);
              }
              
              handleFlow();
            } else {
              self.props.clearConsensi();
              if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
                document
                  .querySelector('button[type="submit"]')
                  .removeAttribute("disabled");
              }
              if (ws_result.codRes) {
                utils.showErrorModal(ws_result.desRes, ws_result.codRes);
              } else {
                utils.showErrorModal(ws_result.message);
              }
            }
          }
        },
        err => {
          console.log(err);
          if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
            document
              .querySelector('button[type="submit"]')
              .removeAttribute("disabled");
          }
          self.props.clearConsensi();
          this.setState({
            loading: false
          });
          utils.showErrorModal("Errore generico, riprova tra poco.");
        }
      );
    } else {
      self.submitBtn.removeAttribute("disabled");
      self.setState({
        loading: false
      });
    }
  }
  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    this.submitBtn.setAttribute("disabled", true);

    let self = this;
    self.setState({
      loading: true
    });
    const global_state = utils.getState();
    /*let invalid_user_data = !this.props.telefono || this.props.telefono == "" || !this.props.email || this.props.email == "";
    if (((global_state.utente && global_state.utente.token && global_state.utente.token !== '') || !this.props.recap_cf_accettato) && !invalid_user_data) {*/
    const validDatiPersonali = (
      global_state.utente &&
      typeof global_state.utente != 'undefined' &&
      global_state.utente.nome &&
      typeof global_state.utente.nome != 'undefined' &&
      global_state.utente.token &&
      global_state.utente.token !== ""
    );
    const validRecap = !this.props.recap_cf_accettato;
    if (validDatiPersonali || validRecap) {
      self.validateConsensiAndSubmit(self);
    } else if (
      (!self.props.oppID || self.props.oppID == "") &&
      this.validateForm()
    ) {
      //Se tutti i campi del form sono validi e non sto modificando
      if (self.state.cap && self.state.cap != "") {
        let indiricap = self.state.cap;
        
        if (!isNaN(self.state.cap)) {
          indiricap = "Italia, " + indiricap;
        } else {
          indiricap = indiricap + ", " + self.state.citta;
        }

        var geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: indiricap }, function (results, status) {
          if (status == "OK") {
            let lat = results[0].geometry.location.lat();
            let lng = results[0].geometry.location.lng();
            if (
              results[0] &&
              results[0].address_components &&
              results[0].address_components.length > 0
            ) {
              results[0].address_components.forEach(function (ac) {
                let isProvincia =
                  ac.types.indexOf("administrative_area_level_2") != -1;
                if (isProvincia) {
                  self.state.provincia = ac.short_name;
                }
                let isComune =
                  ac.types.indexOf("administrative_area_level_3") != -1;
                if (isComune) {
                  self.state.comune = ac.short_name;
                }
                let isCap = ac.types.indexOf("postal_code") != -1;
                if (isCap) {
                  self.state.cap_ricavato_gmaps = ac.short_name;
                }
              });
              self.state.formatted_address = results[0].formatted_address;
            }
            self.props.setDoveNoReset({
              luogo: global_state.luogo,
              coordinate_luogo: {
                lat: lat,
                lng: lng
              }
            });
            let cap_to_send = self.state.cap;
            if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
              cap_to_send = self.state.formatted_address;
            }
            self.props.setDatiPersonali({
              nome: self.state.nome,
              cognome: self.state.cognome,
              email: self.state.email,
              telefono: self.state.telefono,
              cap: cap_to_send,
              provincia: self.state.provincia,
              comune: self.state.comune,
              impiego: self.state.impiego,
              iscrittoCameraCommercio: self.state.iscrittoCameraCommercio,
              tipoAzienda: self.state.tipoAzienda,
            });
            self.validateConsensiAndSubmit(self);
          } else {
            if (global_state.prodotto == -1 || utils.getState().prodotto == 3 || global_state.prodotto == 5) {
              utils.showErrorModal("Indirizzo non trovato");
              self.submitBtn.removeAttribute("disabled");
              self.setState({
                loading: false
              });
            } else {
              utils.showErrorModal("Cap non trovato");
              self.submitBtn.removeAttribute("disabled");
              self.setState({
                loading: false
              });
            }
          }
        });
      } else {
        utils.showErrorModal("CAP obbligatorio");
        self.submitBtn.removeAttribute("disabled");
        self.setState({
          loading: false
        });
      }
    } else if (self.props.oppID && self.props.oppID != "") {
      self.validateConsensiAndSubmit(self);
    } else {
      self.submitBtn.removeAttribute("disabled");
      self.setState({
        loading: false
      });
    }
  }

  validateRequired(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      valid = true;
    }
    return valid;
  }

  validateOnlyText(val) {
    let valid = false;
    if (val && typeof val == "string" && val.length > 1) {
      var re = /[^0-9]$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  }

  validateEmail(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  }

  validateRb(key) {
    return (
      document.querySelectorAll('input[name="' + key + '"]:checked').length > 0
    );
  }

  validateAcceptedRb(key) {
    const radios = document.querySelectorAll('input[name="' + key + '"]:checked');

    return (
      radios.length > 0 && radios[0].value == 1
    );
  }

  validatePhone(val) {
    let valid = false;
    if (val && val && typeof val == "string" && val.length > 1) {
      var re = /^[0-9]{8,11}$/;
      valid = re.test(String(val).toLowerCase());
    }
    return valid;
  }

  validateCap(val) {
    let valid = false;
    if (
      val &&
      val &&
      typeof val == "string" &&
      val.length > 1 &&
      Number(val) >= 10 && Number(val) <= 98168
    ) {
      var re = /^[0-9]{5}$/;
      valid = re.test(String(val).toLowerCase());
      const global_state = utils.getState();
      if (global_state.prodotto == -1 || global_state.prodotto == 3 || global_state.prodotto == 5) {
        valid = val.length > 2;
      }
    }
    return valid;
  }

  validateForm() {
    let elementsToValidate;
    let prod = parseInt(utils.getState().prodotto);
    switch (prod) {
      case -1:
        elementsToValidate = [
          "nome",
          "cognome",
          "email",
          "telefono",
          "citta",
          "cap",
          "impiego"
        ];
        break;
      case 3:
        elementsToValidate = [
          "nome",
          "cognome",
          "email",
          "telefono",
          "citta",
          "cap",
          "impiego"
        ];
        break;
      case 4:
        if (utils.getState().found_db_compass) {
          elementsToValidate = [
            "nome",
            "cognome",
            "email",
            "telefono",
            "cap",
            "impiego",
          ];
        } else {
          elementsToValidate = [
            "nome",
            "cognome",
            "email",
            "telefono",
            "cap",
            "impiego",
            "valutazione",
          ];
        }
        break;
      case 5:
        elementsToValidate = [
          "nome",
          "cognome",
          "email",
          "telefono",
          "citta",
          "cap",
          "iscrittoCameraCommercio",
          "tipoAzienda"
        ];
        break;
      default:
        if (utils.getState().found_db_compass) {
          elementsToValidate = [
            "nome",
            "cognome",
            "email",
            "telefono",
            "cap",
            "impiego",
            "consolidamento"
          ];
        } else {
          elementsToValidate = [
            "nome",
            "cognome",
            "email",
            "telefono",
            "cap",
            "impiego",
            "valutazione",
            "consolidamento"
          ];
        }
    }

    //2021-06-23 Il marketing non vuole la validazione sul ricontatto perchè farebbe perdere clienti
    /*if (utils.getState().ricontatto) { //Più distante di tot km dalla filiale
      elementsToValidate.push("distante");
    }*/

    let self = this;
    let errors;

    elementsToValidate.forEach(function (element) {
      const gState = utils.getState();
      if (element == 'consolidamento' && gState.access_route=='/clink') {
        return;
      }
      const htmlInput = document.querySelector('input[name="' + element + '"]');
      if (htmlInput) {
        let validations = htmlInput.dataset.validation
          ? htmlInput.dataset.validation.split("|")
          : [];
        validations.forEach(function (validation) {
          //Scorro tutti i tipi di validazione richiesti
          let errors = self.state.errors; //Recupero lo stato degli errori prima dell'elaborazione
          if (validation === "rb") {
            errors = self.validate(validation, element, "", errors);
          } else {
            errors = self.validate(validation, element, htmlInput.value, errors);
          }
  
          //Reimposto lo stato degli errori
          self.setState({
            errors: errors
          });
        });
      }
    });

    let errori = false;
    elementsToValidate.forEach(function (element) {
      errori =
        errori ||
        (self.state.errors[element] && self.state.errors[element] !== "");
    });
    if (errori) {
      window.$("html,body").animate({
        scrollTop:
          window.$(".inputContainer:not(.valid)").offset().top +
          window.$(".inputContainer:not(.valid)").height() / 2 -
          300
      });
      console.log("Scrollo");
    }
    return !errori;
  }

  handleAutofill(e) {
    this.validate("citta3", "citta", this.state.citta, this.state.errors);
  }

  validate(validation, key, value, errors) {
    let self = this;
    const global_state = utils.getState();
    // if (!global_state.found_db_compass) {
    //   if (this.state.valutazione === '' || this.state.valutazione === false) {
    //     errors['valutazione'] = 'il consenso è obbligatorio per il prosieguo del processo';
    //   }
    // }
    if (validation && validation == "required") {
      //Nel caso sia un campo richiesto
      if (!this.validateRequired(value)) {
        //Se non è valido
        errors[key] = "Campo obbligatorio (min. 2 caratteri)"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }
    } else if (validation && validation == "only-text") {
      if (!this.validateOnlyText(value)) {
        errors[key] = "Inserire solo caratteri alfabetici"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }
    } else if (validation && validation == "email") {
      if (!this.validateEmail(value)) {
        errors[key] = "Formato email non corretto"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }
    } else if (validation && validation == "rb") {
      if (!this.validateRb(key)) {
        errors[key] = "Selezionare un valore"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }
    } else if (validation && validation == "valutazionerb") {
      if (!global_state.found_db_compass) {
        if (!this.validateAcceptedRb(key)) {
          errors[key] = "il consenso è obbligatorio per il prosieguo del processo"; //Mostro l'errore
        } else {
          errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
        }
      }
    } else if (validation && validation == "phone") {
      if (!this.validatePhone(value)) {
        errors[key] = "Formato telefono non corretto"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }
    } else if (
      validation &&
      (validation == "citta1" ||
        validation == "citta2" ||
        validation == "cittaundefined")
    ) {
      if (!this.validateOnlyText(value)) {
        errors[key] = "Inserire solo caratteri alfabetici"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }
    } else if (validation && (validation == "citta-1" || validation == "citta3" || validation == "citta5")) {
      if (!this.validateOnlyText(value)) {
        errors[key] = "Inserire solo caratteri alfabetici"; //Mostro l'errore
      } else {
        errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
      }

      /*var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: "Italy, " + value }, function (
        results,
        status
      ) {
        if (status == "OK") {
          self.setState({
            latTarget: results[0].geometry.location.lat(),
            longTarget: results[0].geometry.location.lng()
          });
        }
      })*/
      let search = new window.mapkit.Search({
        language: "it",
        getsUserLocation: false,
        limitToCountries: "it"
      });
      search.autocomplete(value, function (err, res) {
        if (!err && res && res.results[0] && res.results[0].coordinate) {
          self.setState({
            latTarget: res.results[0].coordinate.latitude,
            longTarget: res.results[0].coordinate.longitude
          });
        } else {
          console.log(err)
        }
      });
    } else if (validation && validation == 'cap') {
      if (global_state.prodotto != -1 && global_state.prodotto != 3 && global_state.prodotto != 5) {
        if (!this.validateCap(value)) {
          errors[key] = "Formato CAP non corretto"; //Mostro l'errore
        } else {
          errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
        }
      } else {
        if (!this.validateRequired(value)) {
          errors[key] = "Campo obbligatorio (min. 3 caratteri)"; //Mostro l'errore
        } else {
          errors[key] = ""; //Cancello l'errore nel caso fosse stato precedentemente mostrato
        }
      }
    }
    return errors;
  }
  CTAClinkVisible() {
    const gState = utils.getState();
    const visible = (gState.ricontatto && gState.ricontatto_cf) || gState.access_route == '/clink';
    return visible;
  }
  render() {
    const global_state = utils.getState();
    // let radioButtons;
    const prodottoNumerico = this.state.prodotto > 0 ? parseInt(this.state.prodotto).toString() : this.state.prodotto;
    let cityInput = (
      <div className="cell medium-6">
        <FormInputText
          value={this.state.citta}
          type="text"
          click={this.handleClick}
          handler={this.handleInput}
          label="Città*"
          name="citta"
          validate={"required|citta" + prodottoNumerico}
          error={this.state.errors["citta"]}
        />
      </div>
    );

    let capInput = (
      <div className="cell medium-6">
        <div className="relativatore">
          <FormInputText
            // elid="a_search"
            value={this.state.cap}
            type="tel"
            click={this.handleClick}
            handler={this.handleInput}
            label={this.state.cap_label + "*"}
            name="cap"
            validate="required|cap"
            error={this.state.errors["cap"]}
          />
          {/* <div className="suggestions abs">
            <div className="ct">
              {this.state.suggestions.map((sugg, index) => {
                return (
                  <div
                    key={index}
                    suggestion={sugg}
                    onClick={this.autoFill}
                    className="suggestion"
                  >
                    {sugg}
                  </div>
                );
              })}
            </div>
          </div> */}
        </div>
      </div>
    );

    let addressInput = (
      <div className="cell medium-6">
        <div className="relativatore">
          <FormInputText
            elid="a_search"
            class={ !( this.state.latTarget && this.state.longTarget ) ? "is-disabled" : "" }
            disabled={ !( this.state.latTarget && this.state.longTarget ) }
            value={this.state.cap}
            type="text"
            click={this.handleClick}
            kup={this.handleKeyup}
            handler={this.handleInput}
            label={this.state.cap_label + "*"}
            name="cap"
            validate="required|cap"
            error={this.state.errors["cap"]}
          />
          <div className="suggestions abs">
            <div className="ct">
              {this.state.suggestions.map((sugg, index) => {
                return (
                  <div
                    key={index}
                    suggestion={sugg}
                    onClick={this.autoFill}
                    className="suggestion"
                  >
                    {sugg}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );

    let nameInput = (<FormInputText
      value={this.state.nome}
      type="text"
      click={this.handleClick}
      handler={this.handleInput}
      label="Nome*"
      name="nome"
      validate="required|only-text"
      error={this.state.errors["nome"]}
    />)
    if (global_state.modificando == true || global_state.flusso_modifica == true || this.state.modificaDatiRiconosciuti) {
      nameInput = (<FormInputTextDisabled label="Nome" name="nome" value={this.state.nome} />);
    }

    let surnameInput = (<FormInputText
      value={this.state.cognome}
      type="text"
      click={this.handleClick}
      handler={this.handleInput}
      label="Cognome*"
      name="cognome"
      validate="required|only-text"
      error={this.state.errors["cognome"]}
    />)
    if (global_state.modificando == true || global_state.flusso_modifica == true || this.state.modificaDatiRiconosciuti) {
      surnameInput = (<FormInputTextDisabled label="Cognome" name="cognome" value={this.state.cognome} />);
    }

    let valid_class = this.state.errors["impiego"] ? "notValid" : "valid";

    let privacy;
    if (global_state.prodotto != -1 && global_state.prodotto != 3 && global_state.prodotto != -2 && !global_state.found_db_compass && global_state.flowSwitch.previousFlow !== 3) {
      //Fissa appuntamento standard (non era nelle liste compass e non e stato effettuato redirect dal flusso C5)
      privacy = (
        <div>
          <h3>
            Esprimi il tuo consenso al trattamento dei dati<br />
            <br />
            Prendi visione delle informative rese da Compass <span className="red-text">ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679</span>,
            della normativa nazionale vigente in materia di protezione dei dati personali e del Codice di condotta per
            i sistemi informativi gestiti da soggetti privati in materia di crediti
                            al consumo affidabilità e puntualità nei pagamenti <a href="/fissa-appuntamento/pdf/COM257F_04_20.pdf" target="_blank">qui scaricabili</a>
          </h3>
          <RadioConsensi
            name="informativa"
            value={this.state.informativa}
            handler={this.handleRadio}
            error={this.state.errors["informativa"]}
            validate="rb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali,
            ivi inclusi i dati relativi all'andamento dei rapporti e i dati relativi all'esposizione
            anche nei confronti delle società del Gruppo Mediobanca, siano trattati da Compass Banca S.p.A
            e da Società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi),
                          per la finalità indicata alla lettera b) in relazione ai prodotti e servizi propri e di terzi.<br />
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
            anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza.
                        </p>
          <RadioConsensi
            name="dati_personali"
            value={this.state.dati_personali}
            handler={this.handleRadio}
            error={this.state.errors["dati_personali"]}
            validate="rb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano trattati da Compass,
            per la finalità di cui alla lettera e), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze,
            gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o
            servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni
            a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
                        </p>
          <RadioConsensi
            name="societa_terze"
            value={this.state.societa_terze}
            handler={this.handleRadio}
            error={this.state.errors["societa_terze"]}
            validate="rb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano comunicati a
            e trattati da Società terze per la finalità indicata alla lettera c) per prodotti o servizi da queste ultime offerti.
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
            anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui
            ciò è prescritto dalle disposizioni di vigilanza
                        </p>
          <RadioConsensi
            name="valutazione"
            value={this.state.valutazione}
            handler={this.handleRadio}
            error={this.state.errors["valutazione"]}
            validate="valutazionerb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali, ivi inclusi quelli particolari,
            siano trattati da Compass Banca S.p.A. e comunicati a terzi (e da questi trattati), per le finalità ivi indicate alle lettere
            a) e d) e che Compass acquisisca dalle Società del Gruppo Mediobanca, che quindi potranno trasmettere, i dati relativi
            all'andamento dei rapporti eventualmente intercorrenti con queste ultime e li tratti per finalità strettamente connesse
            alla valutazione del merito creditizio della presente richiesta o per la valutazione di un nuovo rapporto.
                        </p>
        </div>
      );
    } else if (global_state.prodotto == -2 && !global_state.found_db_compass) {
      privacy = (
        <div>
          <h3>
            Esprimi il tuo consenso al trattamento dei dati<br />
            <br />
            Prendi visione delle informative rese da Compass <span className="red-text">ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679</span>,
            della normativa nazionale vigente in materia di protezione dei dati personali e del Codice di condotta per
            i sistemi informativi gestiti da soggetti privati in materia di crediti
                          al consumo affidabilità e puntualità nei pagamenti <a href="/fissa-appuntamento/pdf/COM257F_04_20.pdf" target="_blank">qui scaricabili</a>
          </h3>
          <RadioConsensi
            name="informativa"
            value={this.state.informativa}
            handler={this.handleRadio}
            error={this.state.errors["informativa"]}
            validate="rb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali,
            ivi inclusi i dati relativi all'andamento dei rapporti e i dati relativi all'esposizione
            anche nei confronti delle società del Gruppo Mediobanca, siano trattati da Compass Banca S.p.A
            e da Società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi),
                        per la finalità indicata alla lettera b) in relazione ai prodotti e servizi propri e di terzi.<br />
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
            anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza.
                      </p>
          <RadioConsensi
            name="dati_personali"
            value={this.state.dati_personali}
            handler={this.handleRadio}
            error={this.state.errors["dati_personali"]}
            validate="rb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano trattati da Compass,
            per la finalità di cui alla lettera e), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze,
            gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o
            servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni
            a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
                      </p>
          <RadioConsensi
            name="societa_terze"
            value={this.state.societa_terze}
            handler={this.handleRadio}
            error={this.state.errors["societa_terze"]}
            validate="rb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano comunicati a
            e trattati da Società terze per la finalità indicata alla lettera c) per prodotti o servizi da queste ultime offerti.
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
            anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui
            ciò è prescritto dalle disposizioni di vigilanza
                      </p>
          <RadioConsensi
            name="valutazione"
            value={this.state.valutazione}
            handler={this.handleRadio}
            error={this.state.errors["valutazione"]}
            validate="valutazionerb"
          />
          <p>
            dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali, ivi inclusi quelli particolari,
            siano trattati da Compass Banca S.p.A. e comunicati a terzi (e da questi trattati), per le finalità ivi indicate alle lettere
            a) e d) e che Compass acquisisca dalle Società del Gruppo Mediobanca, che quindi potranno trasmettere, i dati relativi
            all'andamento dei rapporti eventualmente intercorrenti con queste ultime e li tratti per finalità strettamente connesse
            alla valutazione del merito creditizio della presente richiesta o per la valutazione di un nuovo rapporto.
                      </p>
        </div>
      );
    } else if (global_state.prodotto == 5 && global_state.found_db_compass) {
      //Compass quinto trovato all'interno delle liste già cliente
      <div>
        <h3>
          Preso atto dell’ <a href="/fissa-appuntamento/pdf/Privacy_FA_12_21.pdf" target="_blank">informativa</a>{" "}
          resami da Compass Banca S.p.A.{" "}
          <span className="red-text">ai sensi dell’art. 13 del Regolamento UE 2016/679</span>{" "}
          e della normativa nazionale vigente in materia di protezione dei
          dati personali:
        </h3>
        <RadioConsensi
          name="informativa"
          value={this.state.informativa}
          handler={this.handleRadio}
          error={this.state.errors["informativa"]}
          validate="rb"
        />
        <p>
          dichiarando di aver scaricato e letto l’INFORMATIVA, che i miei dati personali, siano trattati da Compass Banca S.p.A e da Società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi), per la finalità indicata alla lettera b) in relazione ai prodotti e servizi propri e di terzi.
          Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza
        </p>
        <RadioConsensi
          name="dati_personali"
          value={this.state.dati_personali}
          handler={this.handleRadio}
          error={this.state.errors["dati_personali"]}
          validate="rb"
        />
        <p>
          dichiarando di aver scaricato e letto l’INFORMATIVA, che i miei dati personali siano trattati da Compass, per la finalità di cui alla lettera c), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze, gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
          </p>
        <RadioConsensi
          name="societa_terze"
          value={this.state.societa_terze}
          handler={this.handleRadio}
          error={this.state.errors["societa_terze"]}
          validate="rb"
        />
        <p>
          dichiarando di aver scaricato e letto l’INFORMATIVA, che i miei dati personali siano comunicati a e trattati da Società terze per la finalità indicata alla lettera b) per prodotti o servizi da queste ultime offerti. Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui ciò è prescritto dalle disposizioni di vigilanza
          </p>
      </div>
    } else {
      //Compass quinto o ritrovato in liste compass
      privacy = (
        <div>
          <h3>
            Prendi visione della informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati personali <a href="/fissa-appuntamento/pdf/Privacy_FA_12_21.pdf" target="_blank">qui scaricabili</a>
          </h3>
          <RadioConsensi
            name="informativa"
            value={this.state.informativa}
            handler={this.handleRadio}
            error={this.state.errors["informativa"]}
            validate="rb"
          />
          <p>
            a che i miei dati personali siano trattati per la finalità di cui alla lettera b), da parte di Compass e di altre società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi), in relazione a prodotti e servizi propri e di terzi.
            Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza.
          </p>
          <RadioConsensi
            name="dati_personali"
            value={this.state.dati_personali}
            handler={this.handleRadio}
            error={this.state.errors["dati_personali"]}
            validate="rb"
          />
          <p>
            a che i miei dati personali siano trattati da Compass per la finalità di cui alla lettera c), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze, gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
          </p>
          <RadioConsensi
            name="societa_terze"
            value={this.state.societa_terze}
            handler={this.handleRadio}
            error={this.state.errors["societa_terze"]}
            validate="rb"
          />
          <p>
            a che i miei dati personali siano trattati per la finalità di cui alla lettera b), da parte di Società terze, per prodotti e servizi da queste ultime offerti. Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti, anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui ciò è prescritto dalle disposizioni di vigilanza.
          </p>
        </div>
      );
    }

    return (
      <div>
        <Spinner
          visible={this.state.loading}
          solid={utils.getState().utente && utils.getState().utente.token}
        />
        <div className="grid-x grid-padding-x">
          <div className="cell animations-container">
            <div className="panel gsap-slide">
              <form onSubmit={this.handleSubmit} id="form-dati-personali">
                <div
                  className={
                    checkRiepilogoInfo(
                      this.props.recap_cf_accettato,
                      global_state.prodotto,
                      global_state.utente,
                      this.state.modificaDatiRiconosciuti
                    )/*|| invalid_user_data*/
                    ? "hidden"
                    : ""
                  }
                >
                  <h2 className="recap-cf-title">
                    {"Ciao " + this.state.nome}.
                    <br />
                    {global_state.access_route != '/clink' ? "I tuoi contatti sono ancora questi?" : "Conferma i tuoi dati e un consulente Compass ti contatterà per gestire la tua richiesta"}
                  </h2>
                  <RecapCF
                    email={this.state.email}
                    telefono={this.state.telefono}
                    handleEdit={this.handleEdit}
                    handleModificaDati={this.handleModificaDati}
                  />
                </div>

                <div
                  className={
                    checkEditInfo(
                      this.props.recap_cf_accettato,
                      this.props.oppID,
                      global_state.prodotto,
                      global_state.utente,
                      this.state.modificaDatiRiconosciuti
                    )
                    ? ""
                    : "hidden"
                  }
                >
                  {
                  global_state.prodotto == 5 ? 
                  (<h2 className="topEl">Inserisci i dati <span className="text--secondary-color">del legale rappresentante</span></h2>) 
                  : 
                  (<h2 className="topEl">Inserisci i tuoi riferimenti</h2>)
                  }
                  <div className="grid-container container-input-dati-personali">
                    <div className="grid-x grid-padding-x">
                      <div className="cell medium-6">
                        {nameInput}
                      </div>
                      <div className="cell medium-6">
                        {surnameInput}
                      </div>
                      <div className="cell medium-6">
                        <FormInputText
                          value={this.state.email}
                          type="email"
                          click={this.handleClick}
                          handler={this.handleInput}
                          label="Email*"
                          name="email"
                          validate="required|email"
                          error={this.state.errors["email"]}
                        />
                      </div>
                      <div className="cell medium-6">
                        <FormInputText
                          value={this.state.telefono}
                          type="tel"
                          click={this.handleClick}
                          handler={this.handleInput}
                          label="Telefono*"
                          name="telefono"
                          validate="required|phone"
                          error={this.state.errors["telefono"]}
                        />
                      </div>
                      {(global_state.prodotto == -1 || this.state.prodotto == 3 || global_state.prodotto == 5) ? cityInput : null}
                      {(global_state.prodotto != -1 && this.state.prodotto != 3 && global_state.prodotto != 5) ? capInput : null}
                      {(global_state.prodotto == -1 || this.state.prodotto == 3 || global_state.prodotto == 5) ? addressInput : null}
                      {/* <div className="cell medium-6">
                        <div className="relativatore">
                          <FormInputText
                            elid="a_search"
                            class={
                              !(
                                this.state.latTarget && this.state.longTarget
                              ) && this.state.prodotto == 3
                                ? "is-disabled"
                                : ""
                            }
                            disabled={
                              !(
                                this.state.latTarget && this.state.longTarget
                              ) && this.state.prodotto == 3
                            }
                            value={this.state.cap}
                            type={this.state.prodotto == 3 ? "text" : "tel"}
                            click={this.handleClick}
                            kup={this.handleKeyup}
                            handler={this.handleInput}
                            label={this.state.cap_label + "*"}
                            name="cap"
                            validate="required|cap"
                            error={this.state.errors["cap"]}
                          />
                          <div className="suggestions abs">
                            <div className="ct">
                              {this.state.suggestions.map((sugg, index) => {
                                return (
                                  <div
                                    key={index}
                                    suggestion={sugg}
                                    onClick={this.autoFill}
                                    className="suggestion"
                                  >
                                    {sugg}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  {/* <section className="form-dati-personali__info">
                    <h2>Che tipo di impiego hai?</h2>
                    <div className="grid-container">
                      <div className="grid-x grid-padding-x">
                        <div
                          className={
                            "cell" +
                            (utils.getState().prodotto !== 3
                              ? " medium-6 medium-offset-3"
                              : " medium-10 medium-offset-1")
                          }
                        >
                          <div
                            className="grid-x grid-padding-x"
                            id="radio-impiego"
                          >
                            {radioButtons}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section> */}
                  <BoxClink clink={this.state.clink} handler={this.handleClink} visible={(global_state.ricontatto == true && global_state.ricontatto_cf == true)} />
                  <FormAuxiliaryInfo valid_class={this.state.valid_class} currentState={this.state} handleCheck={this.handleCheck} />
                </div>

                {/*<Distante errors={this.state.errors} handleCheck={this.handleVeniamoDaTe} ricontatto={global_state.ricontatto} ricontatto_cf={global_state.ricontatto_cf} />*/}

                <Consolidamento errors={this.state.errors} handleCheck={this.handleConsolidamento} prodotto={global_state.prodotto} />

                <div className="privacyCompressor">
                  <h2>Un’ultima cosa: abbiamo bisogno del tuo consenso per fissare un appuntamento e valutare l’eventuale richiesta di credito.</h2>
                  {privacy}
                </div>

                <button type="submit" className={"bottone " + (global_state.access_route == '/clink' ? 'hidden' : '')} ref={submitBtn => { this.submitBtn = submitBtn }}>
                  fissa appuntamento
                </button>
                {/*<div id="cta-distante" className={(global_state.ricontatto != true || global_state.ricontatto_cf != true) ? 'hidden' : ''}>
                  <p>
                    La filiale è troppo distante?
                  </p>
                  <button type="button" className="negativeButton" onClick={this.sendRicontatto}>
                    Fissa un appuntamento con un nostro consulente. Veniamo noi da te!
                  </button>
                </div>*/}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class FormInputText extends React.Component {
  constructor(props) {
    super(props);
  }
  previeniAsterisco(e) {
    if (e.keyCode == 187) {
      //Prevengo l'inserimento dell'asterisco
      e.preventDefault();
      return false;
    }
  }
  render() {
    let error = this.props.error ? this.props.error : "";

    return (
      <div
        className={`inputContainer ${this.props.class} ${
          error == "" && this.props.value != "" ? "valid" : ""
          } ${
          this.props.error != "" && this.props.value != "" ? "notValid" : ""
          } ${this.props.value != "" ? "filled" : ""}`}
      >
        <input
          type={this.props.type}
          onKeyDown={this.previeniAsterisco}
          id={this.props.elid}
          data-validation={this.props.validate}
          name={this.props.name}
          onClick={this.props.click}
          onKeyUp={this.props.kup}
          onChange={this.props.handler.bind(this, this.props.validate)}
          onBlur={this.props.blur}
          value={this.props.value}
          disabled={this.props.disabled}
          autoComplete="off"
        />
        <label>{this.props.label}</label>
        <div className="error">{this.props.error}</div>
        <div className="icon">
          <img src="./img/check.png" alt="Verificato" />
        </div>
      </div>
    );
  }
}

// class FormRadioButton extends React.Component {
//   constructor(props) {
//     super(props);
//   }
//   render() {
//     return (
//       <div className={"checkContainer"} onClick={this.props.handler}>
//         <div className="check">
//           <input
//             type="radio"
//             data-validation={this.props.validate}
//             name={this.props.name}
//             value={this.props.value}
//           />
//           <svg
//             width="25"
//             height="25"
//             viewBox="0 0 25 25"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               fillRule="evenodd"
//               clipRule="evenodd"
//               d="M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
//               fill="#333333"
//             />
//           </svg>
//         </div>
//         <div className="radioLabel">{this.props.label}</div>
//         <div className="clear"></div>
//       </div>
//     );
//   }
// }

class RadioConsensi extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const validField = !(typeof this.props.error != "undefined" && this.props.error != "");
    const validClass = !validField ? " notValid" : " valid";
    const classFintoErrore = 'fintoErrore ' + ((this.props.name == 'valutazione' && (!this.props.error || this.props.error == "")) ? 'hidden' : '');
    return (
      <React.Fragment>
        <div className={"multiradioContainer" + validClass } >
          <div className="content-radio" onClick={this.props.handler}>
            <div className={"check"}>
              <input type="radio" name={this.props.name} data-validation={this.props.validate ? this.props.validate : "" } value="1" />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    this.props.value !== ""
                      ? "M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
                      : "M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z"
                  }
                  fill="#333333"
                />
              </svg>
            </div>
            <label className="radioLabel">Acconsento</label>
          </div>
          <div className="content-radio" onClick={this.props.handler}>
            <div className={"check"}>
              <input type="radio" name={this.props.name} value="-1" />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    this.props.value !== ""
                      ? "M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
                      : "M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z"
                  }
                  fill="#333333"
                />
              </svg>
            </div>
            <label className="radioLabel">Non acconsento</label>
          </div>
        </div>
        {/* <div className={classFintoErrore}>
          il consenso è obbligatorio per il prosieguo del processo
        </div> */}
        <div className="error">
          {!validField ? this.props.error : ""}
        </div>
      </React.Fragment>
    );
  }
}

function validaConsensi(self) {
  let valid = true;
  let errors = self.state.errors;
  let consensi = window.document.querySelectorAll(".multiradioContainer");
  if (consensi) {
    for (let i = 0; i < consensi.length; i++) {
      let consenso = consensi[i];
      let radio = consenso.querySelector("input");
      let name = radio.name;
      if (name != "valutazione") {
        if (self.state[name] === "") {
          valid = false;
          errors[name] = "Seleziona un'opzione";
        } else {
          errors[name] = "";
        }
      } else if (name == "valutazione" && (!self.state.hasOwnProperty(name) || self.state[name] === "" || self.state[name] === false)) {
        valid = false;
        errors[name] = "il consenso è obbligatorio per il prosieguo del processo";
      }
    }
  }
  self.setState({ errors: errors });
  if (!valid) {
    const invConsenso = document.querySelector(".multiradioContainer:not(.valid)");
    const top = invConsenso ? invConsenso.offsetTop : null;
    if (top) {
      window.scrollTo(
        0,
        top - 120
      );
    }
  }
  return valid;
}

export default connect(mapStateToProps, mapDispatchToProps)(FormDatiPersonali);



// WEBPACK FOOTER //
// ./src/components/dati_personali/form.js